import { useEffect, useState } from "react";
// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import { useNavigate } from "react-router-dom";
import {
  Box,
  ClickAwayListener,
  Dialog,
  DialogContent,
  FormControl,
  IconButton,
  InputAdornment,
  MenuItem,
  Paper,
  Popper,
  Select,
  Tab,
  Tabs,
} from "@mui/material";
import moment from "moment";
import { DayPicker } from "react-day-picker";
import MDInput from "components/MDInput";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import ClearIcon from "@mui/icons-material/Clear";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
import WarnModal from "components/DeleteModal";
import Loader from "helpers/constants/Loader";
import ShowToast from "components/MDToast";
import Pagination from "components/Pagination";

import {
  useGetReturnExchangeListingsMutation,
  useDeleteReturnExchangeMutation,
  useUpdateReturnExchangeStatusMutation,
} from "services/returnExchange";
import MDBadge from "components/MDBadge";
import { useReturnAcceptRejectMutation } from "services/returnExchange";
import { useExchangeAcceptRejectMutation } from "services/returnExchange";
import { useSetRefundAmountMutation } from "services/returnExchange";
import MDButton from "components/MDButton";
import { getFromStorage } from "helpers";
import { STORAGE_KEYS } from "helpers";
import useTranslation from "hooks/Translation";

const RETURN_STATUS = [
  [1, "RETURN_REQUEST_SENT"],
  [2, "RETURN_REQUEST_RECEIVED"],
  [3, "VENDOR_REQUEST_ACCEPTED"],
  [4, "VENDOR_REQUEST_REJECTED"],
  [5, "RETURN_PICKUP_SCHEDULED"],
  [6, "RETURN_PICKED_UP"],
  [7, "RETURN_IN_TRANSIT"],
  [8, "RETURN_RECEIVED_BY_VENDOR"],
  [9, "RETURN_COMPLETED"],
];

// Custom labels for each status
const STATUS_LABELS = {
  1: "Order Placed",
  2: "Request Received",
  3: "Vendor Accepted",
  4: "Vendor Rejected",
  5: "Pickup Scheduled",
  6: "Picked Up",
  7: "In Transit",
  8: "Received by Vendor",
  9: "Return Completed",
};
const EXCHANGE_STATUS = [
  [1, "EXCHANGE_REQUEST"],
  [2, "VENDOR_REQUEST_ACCEPT"],
  [3, "VENDOR_REQUEST_REJECT"],
  [4, "EXCHANGE_INITIATE"],
  [5, "ITEM_PICKED_UP"],
  [6, "ITEM_IN_TRANSIT"],
  [7, "ITEM_RECEIVED_BY_VENDOR"],
  [8, "REPLACEMENT_DISPATCHED"],
  [9, "REPLACEMENT_DELIVERED"],
  [10, "EXCHANGE_COMPLETE"],
];
const EXCHANGE_STATUS_LABELS = {
  1: "Exchange Request",
  2: "Vendor Accepted Request",
  3: "Vendor Rejected Request",
  4: "Exchange Initiated",
  5: "Item Picked Up",
  6: "Item In Transit",
  7: "Item Received by Vendor",
  8: "Replacement Dispatched",
  9: "Replacement Delivered",
  10: "Exchange Complete",
};
const ReturnExchangeManagement = () => {
  const currency = getFromStorage(STORAGE_KEYS.currency);
  // const { columns, rows, tabValue, setTabValue } = orderTableData();
  const navigate = useNavigate();
  const t = useTranslation();
  const [deleteOrder] = useDeleteReturnExchangeMutation();
  const [orderStatus] = useUpdateReturnExchangeStatusMutation();
  const [returnAcceptReject] = useReturnAcceptRejectMutation();
  const [exchangeAcceptReject] = useExchangeAcceptRejectMutation();
  const [setAmount] = useSetRefundAmountMutation();
  const [getOrderListing, { isLoading }] =
    useGetReturnExchangeListingsMutation();
  const [month, setMonth] = useState(new Date());
  const [range, setRange] = useState({
    from: undefined,
    to: undefined,
  });
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(false);
  const [tabsOrientation, setTabsOrientation] = useState("horizontal");
  const [tabValue, setTabValue] = useState(0);

  const [refundAmount, setRefundAmount] = useState("");
  const [error, setError] = useState(false);
  const [orderData, setOrderData] = useState([]);
  const [selectedId, setSelected] = useState("");
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalRecords, setTotalRecords] = useState(10);
  const [refundModal, setRefundModal] = useState(false);
  const [selectedExchange, setSelectedExchange] = useState(false);

  const handleDeleteOrder = async (id) => {
    try {
      const response = await deleteOrder({ id: id }).unwrap();

      if (response?.status === 200) {
        ShowToast("Order deleted successfully", "success");
        getData();
        setDeleteModalOpen(false);
      }
    } catch (error) {
      console.log(error, "errror");
      ShowToast(error?.data?.message || "", "error");
    }
  };

  const handleSetRefundAmount = async (id, type) => {
    if (!refundAmount) {
      return;
    }

    const body = {
      amount: refundAmount,
    };
    try {
      const response = await setAmount({
        body,
        id,
        type: type === 0 ? 2 : 1,
      }).unwrap();

      if (response?.status === 200) {
        ShowToast("Refund amount sent", "success");
        setRefundAmount("");
        setRefundModal(false);
        getData();
      }
    } catch (error) {
      console.log(error, "errror");
      ShowToast(error?.data?.message || "", "error");
    }
  };

  const handleAcceptRejectReturn = async (id, type) => {
    const body = {
      type: type,
      vendor_request_rejected_date: new Date().toISOString(),
    };

    const body2 = {
      type: type,
      vendor_request_accepted_date: new Date().toISOString(),
    };

    try {
      const response = await returnAcceptReject({
        body: type === 1 ? body2 : body,
        id,
      }).unwrap();
      if (response?.status === 200) {
        if (type === 1) {
          ShowToast("Order accepted successfully", "success");
        } else {
          ShowToast("Order rejected successfully", "success");
        }

        getData();
      }
    } catch (error) {
      console.log(error, "errror");
      ShowToast(error?.data?.message || "", "error");
    }
  };

  const handleAcceptRejectExchange = async (id, type) => {
    const body = {
      type: type,
      vendor_request_rejected_date: new Date().toISOString(),
    };

    const body2 = {
      type: type,
      vendor_request_accepted_date: new Date().toISOString(),
    };

    try {
      const response = await exchangeAcceptReject({
        body: type === 1 ? body2 : body,
        id,
      }).unwrap();
      if (response?.status === 200) {
        if (type === 1) {
          ShowToast("Order accepted successfully", "success");
        } else {
          ShowToast("Order rejected successfully", "success");
        }
        getData();
      }
    } catch (error) {
      console.log(error, "errror");
      ShowToast(error?.data?.message || "", "error");
    }
  };

  const Job = ({ title, description }) => (
    <MDBox lineHeight={1} textAlign="left" sx={{ minWidth: "140px" }}>
      <MDTypography display="block" variant="caption" fontWeight="medium">
        {title}
      </MDTypography>
      <MDTypography variant="caption">{description}</MDTypography>
    </MDBox>
  );
  const Amount = ({ title, description }) => (
    <MDBox lineHeight={1} textAlign="center" sx={{ minWidth: "140px" }}>
      <MDTypography display="block" variant="caption" fontWeight="medium">
        {title}
      </MDTypography>
      <MDTypography variant="caption">{description}</MDTypography>
    </MDBox>
  );

  const Extra = ({ title, description }) => (
    <MDBox lineHeight={1} textAlign="left" sx={{ minWidth: "180px" }}>
      <MDTypography display="block" variant="caption" fontWeight="medium">
        {title}
      </MDTypography>
      <MDTypography variant="caption">{description}</MDTypography>
    </MDBox>
  );

  const Name = ({ title, description }) => (
    <MDBox lineHeight={1} textAlign="left" sx={{ minWidth: "120px" }}>
      <MDTypography display="block" variant="caption" fontWeight="medium">
        {title}
      </MDTypography>
      <MDTypography variant="caption">{description}</MDTypography>
    </MDBox>
  );

  const totalPages = Math.ceil(totalRecords / limit);

  const getData = async (page) => {
    try {
      let body = {
        start: page,
        length: 10,
        type: tabValue == 0 ? 2 : 1,
        search: "",
        ...(range?.from
          ? { start_date: moment(range?.from).startOf("day") }
          : {}),
        ...(range?.to ? { end_date: moment(range?.to).startOf("day") } : {}),
      };

      console.log(body, "body");

      const res = await getOrderListing({ body: body }).unwrap();
      if (res?.status) {
        setOrderData(res?.data?.response_object || []);
        setTotalRecords(res?.data?.total_records);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleRequestStatus = async (status, id) => {
    const currentDate = new Date().toISOString();
    const statusValue = Number(status.target.value);

    const statusMapping = {
      1: {
        type: tabValue === 0 ? 2 : 1,
        return_request_sent_date: currentDate,
      },
      2: {
        type: tabValue === 0 ? 2 : 1,
        return_request_received_date: currentDate,
      },
      3: {
        type: tabValue === 0 ? 2 : 1,
        vendor_request_accepted_date: currentDate,
      },
      4: {
        type: tabValue === 0 ? 2 : 1,
        vendor_request_rejected_date: currentDate,
      },
      5: {
        type: tabValue === 0 ? 2 : 1,
        return_pickup_scheduled_date: currentDate,
      },
      6: { type: tabValue === 0 ? 2 : 1, return_picked_up_date: currentDate },
      7: { type: tabValue === 0 ? 2 : 1, return_in_transit_date: currentDate },
      8: {
        type: tabValue === 0 ? 2 : 1,
        return_received_by_vendor_date: currentDate,
      },
      9: { type: tabValue === 0 ? 2 : 1, return_completed_date: currentDate },
    };
    const exchangeStatusMapping = {
      1: { type: tabValue === 0 ? 2 : 1, exchange_request_date: currentDate },
      2: {
        type: tabValue === 0 ? 2 : 1,
        vendor_request_accepted_date: currentDate,
      },
      3: {
        type: tabValue === 0 ? 2 : 1,
        vendor_request_reject_date: currentDate,
      },
      4: { type: tabValue === 0 ? 2 : 1, exchange_initiate_date: currentDate },
      5: { type: tabValue === 0 ? 2 : 1, item_picked_up_date: currentDate },
      6: { type: tabValue === 0 ? 2 : 1, item_in_transit_date: currentDate },
      7: {
        type: tabValue === 0 ? 2 : 1,
        item_received_by_vendor_date: currentDate,
      },
      8: {
        type: tabValue === 0 ? 2 : 1,
        replacement_dispatched_date: currentDate,
      },
      9: {
        type: tabValue === 0 ? 2 : 1,
        replacement_delivered_date: currentDate,
      },
      10: {
        type: tabValue === 0 ? 2 : 1,
        exchange_complete_date: currentDate,
      },
    };

    const body =
      tabValue == 1
        ? {
            type: statusMapping[statusValue]?.type,
            ...statusMapping[statusValue],
            Return_status: statusValue,
          }
        : {
            type: exchangeStatusMapping[statusValue]?.type,
            ...exchangeStatusMapping[statusValue],
            exchange_status: statusValue,
          };

    console.log(body, "Generated Body");

    try {
      const response = await orderStatus({ body, id }).unwrap();
      if (response?.status === 200) {
        getData();
        ShowToast("Status updated successfully", "success");
      } else {
        ShowToast("Please try again", "error");
      }
    } catch (error) {
      console.error(error);
      setOrderData([]);
      ShowToast(error?.data?.message || "An error occurred", "error");
    }
  };

  const columns = [
    { Header: t.main.orderId, accessor: "Id", align: "left" },
    { Header: t.main.customerName, accessor: "name", align: "left" },
    { Header: t.main.contact, accessor: "contact", align: "left" },
    { Header: t.main.email, accessor: "email", align: "left" },
    // { Header: "Quantity", accessor: "quantity", align: "left" },
    { Header: t.main.refundAmount, accessor: "price", align: "left" },

    { Header: t.main.totalCostPay, accessor: "cost", align: "left" },
    { Header: t.main.date, accessor: "date", align: "left" },

    { Header: t.main.orderStatus, accessor: "request", align: "center" },
    { Header: t.main.acceptReject, accessor: "req", align: "center" },
    { Header: t.main.setRefund, accessor: "refund", align: "center" },
    { Header: t.main.actions, accessor: "action", align: "center" },
  ];

  if (tabValue === 0) {
    // Find the index of the "Refund Amount" column
    const refundAmountIndex = columns.findIndex(
      (col) => col.accessor === "price"
    );

    // Insert the new field below "Refund Amount"
    columns.splice(refundAmountIndex + 1, 0, {
      Header: t.main.extraPaymentByUser,
      accessor: "extraAmount",
      align: "left",
    });
  }

  const rows = orderData?.map((itx) => {
    const row = {
      Id: <Name title={`#${itx?.order_track_id}` || ""} />,
      name: <Name title={itx?.user || "-"} />,
      contact: <Job title={`${itx?.country_code}-${itx?.phone_no}` || "-"} />,
      email: <Job title={`${itx?.email}` || "-"} />,
      price: (
        <Job
          title={`${currency === "USD" ? "USD" : "AED"} ${
            tabValue === 0 ? itx?.refund_pay : itx?.amount_pay
          }`}
        />
      ),
      cost: (
        <Job
          title={`${currency === "USD" ? "USD" : "AED"} ${
            tabValue === 0 ? itx?.Exchange_total_cost_pay : itx?.total_cost_pay
          }`}
        />
      ),
      date: <Name title={moment(itx?.created_at).format("MM/DD/YYYY")} />,
      request: (
        <MDBox sx={{ width: tabValue === 0 ? 180 : 150 }}>
          <FormControl fullWidth>
            <Select
              className="select_div"
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={
                tabValue == 1
                  ? String(itx?.Return_status)
                  : String(itx?.exchange_status)
              }
              disabled={
                itx?.Return_status === 4 ||
                itx?.exchange_status === 3 ||
                itx?.Return_status === 9 ||
                itx?.exchange_status === 10
              }
              displayEmpty
              onChange={(val) => handleRequestStatus(val, itx?.id)}
              sx={{
                border: "1px solid grey", // Custom border color
                borderRadius: "6px", // Add border radius
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "grey", // Default border color
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "grey", // Hover border color
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "grey", // Focused border color
                },
              }}
            >
              {tabValue === 1
                ? RETURN_STATUS?.filter(
                    ([value]) =>
                      (value !== 3 || itx?.Return_status === 3) &&
                      (value !== 4 || itx?.Return_status === 4)
                  ).map(([value, status]) => (
                    <MenuItem
                      key={value}
                      value={String(value)}
                      disabled={
                        itx?.Return_status === 2
                          ? value > itx?.Return_status + 2
                          : itx?.Return_status === 3
                          ? value > itx?.Return_status + 2
                          : value > itx?.Return_status + 1 ||
                            value < itx?.Return_status
                      }
                    >
                      {STATUS_LABELS[value] || status}
                    </MenuItem>
                  ))
                : EXCHANGE_STATUS?.filter(
                    ([value]) =>
                      (value !== 2 || itx?.exchange_status === 2) &&
                      (value !== 3 || itx?.exchange_status === 3)
                  )?.map(([value, status]) => (
                    <MenuItem
                      key={value}
                      value={String(value)}
                      disabled={
                        itx?.exchange_status === 2
                          ? value > itx?.exchange_status + 2
                          : itx?.exchange_status === 3
                          ? value > itx?.exchange_status + 1
                          : value > itx?.exchange_status + 1 ||
                            value < itx?.exchange_status
                      }
                    >
                      {EXCHANGE_STATUS_LABELS[value] || status}
                    </MenuItem>
                  ))}
            </Select>
          </FormControl>
        </MDBox>
      ),
      req: (
        <MDBox sx={{ display: "flex" }}>
          {itx?.Return_status === 4 ||
          itx?.exchange_status === 3 ? null : itx?.Return_status >= 3 ||
            itx?.exchange_status >= 2 ? (
            <MDBox
              sx={{ cursor: "pointer" }}
              // onClick={() => {
              //   if (tabValue === 0) {
              //     handleAcceptRejectExchange(itx?.id, 1);
              //   } else {
              //     handleAcceptRejectReturn(itx?.id, 1);
              //   }
              // }}
            >
              <MDBadge
                badgeContent="Accepted"
                color="success"
                variant="gradient"
                size="md"
              />
            </MDBox>
          ) : (
            <MDBox
              sx={{ cursor: "pointer" }}
              onClick={() => {
                if (tabValue === 0) {
                  handleAcceptRejectExchange(itx?.id, 1);
                } else {
                  handleAcceptRejectReturn(itx?.id, 1);
                }
              }}
            >
              <MDBadge
                badgeContent="Accept"
                color="success"
                variant="gradient"
                size="md"
              />
            </MDBox>
          )}

          {itx?.Return_status === 4 || itx?.exchange_status === 3 ? (
            <MDBox sx={{ cursor: "pointer" }}>
              <MDBadge
                badgeContent="Rejected"
                color="error"
                variant="gradient"
                size="md"
              />
            </MDBox>
          ) : itx?.Return_status > 3 || itx?.exchange_status >= 2 ? null : (
            <MDBox
              sx={{ cursor: "pointer" }}
              onClick={() => {
                if (tabValue === 0) {
                  handleAcceptRejectExchange(itx?.id, 2);
                } else {
                  handleAcceptRejectReturn(itx?.id, 2);
                }
              }}
            >
              <MDBadge
                badgeContent="Reject"
                color="error"
                variant="gradient"
                size="md"
              />
            </MDBox>
          )}
        </MDBox>
      ),
      refund: (
        <MDBox>
          {(tabValue === 0 && itx?.exchange_status === 10) ||
          (tabValue === 1 && itx?.Return_status === 9) ? (
            <MDBox>
              {itx?.amount_set_by_vendor?.length ? (
                <Amount
                  title={`${currency === "USD" ? "USD" : "AED"} ${
                    itx?.amount_set_by_vendor
                  }`}
                />
              ) : (
                <MDBox
                  sx={{ cursor: "pointer", minWidth: 100 }}
                  onClick={() => {
                    setSelectedExchange(itx?.id);
                    setRefundModal(true);
                  }}
                >
                  <MDBadge
                    badgeContent="Refund Amount"
                    color="success"
                    variant="gradient"
                    size="md"
                  />
                </MDBox>
              )}
            </MDBox>
          ) : (
            <MDBox>
              {tabValue === 0 ? (
                <MDBadge
                  badgeContent="Exchange not Completed"
                  color="dark"
                  variant="gradient"
                  size="md"
                />
              ) : (
                <MDBadge
                  badgeContent="Return not Completed"
                  color="dark"
                  variant="gradient"
                  size="md"
                />
              )}
            </MDBox>
          )}
        </MDBox>
      ),
      action: (
        <Box className="table_actions">
          <IconButton
            size="small"
            onClick={() =>
              navigate(`/return-exchange/details/${itx?.id}`, {
                state: tabValue === 0 ? 2 : 1,
              })
            }
          >
            <VisibilityIcon />
          </IconButton>

          {/* <IconButton
            size="small"
            onClick={() => {
              setDeleteModalOpen(true);
              setSelected(itx?.id);
            }}
          >
            <DeleteIcon />
          </IconButton> */}
        </Box>
      ),
    };

    // Conditionally add the additional field below the "price" field
    if (tabValue === 0) {
      row.extraAmount = (
        <Extra
          title={`${currency === "USD" ? "USD" : "AED"} ${
            itx?.extra_amount_pay || "--"
          }`}
        />
      );
    }

    return row;
  });

  useEffect(() => {
    getData(page);
  }, [tabValue, page, range?.from, range?.to]);

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  const handleSelect = (selectedRange) => {
    if (selectedRange === undefined) {
      setRange({ from: undefined, to: undefined });
    } else {
      setRange(selectedRange);
      if (
        selectedRange.from !== undefined &&
        selectedRange.to !== undefined &&
        selectedRange.from !== selectedRange.to
      ) {
        setOpen(false);
      }
    }
  };

  const handleMonthChange = (newMonth) => {
    setMonth(newMonth);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setOpen(true);
  };

  const getFormattedRange = () => {
    if (range?.from && range?.to) {
      return `${moment(range.from).format("MM/DD/YYYY")} - ${moment(
        range.to
      ).format("MM/DD/YYYY")}`;
    } else if (range?.from) {
      return moment(range.from).format("MM/DD/YYYY");
    }
    return "";
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleCloseRefund = () => {
    setRefundModal(false);
  };

  const handleSetTabValue = (event, newValue) => setTabValue(newValue);

  return (
    <DashboardLayout>
      <Loader loading={isLoading} />
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                // variant="gradient"
                bgColor="theme-1"
                borderRadius="lg"
                coloredShadow="info"
                sx={{ display: "flex", justifyContent: "space-between" }}
              >
                <MDTypography variant="h6" color="white">
                  {t.main.returnTable}
                </MDTypography>
              </MDBox>

              <MDBox pt={2} pl={2} pr={2}>
                <div style={{ display: "flex", gap: 10 }}>
                  <div className="control_group" style={{ width: "250px" }}>
                    <MDInput
                      // label="Select Date Range"
                      variant="outlined"
                      hiddenLabel
                      className="text_field-range"
                      fullWidth
                      onClick={handleClick}
                      value={getFormattedRange()}
                      placeholder="Select Date Range"
                      InputProps={{
                        readOnly: true,
                        endAdornment: range?.from ? (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => {
                                setRange({
                                  from: undefined,
                                  to: undefined,
                                });
                              }}
                            >
                              <ClearIcon />
                            </IconButton>
                          </InputAdornment>
                        ) : (
                          <InputAdornment position="end">
                            <IconButton>
                              <CalendarTodayIcon />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </div>
                  <Popper
                    open={open}
                    anchorEl={anchorEl}
                    placement="bottom-start"
                    disablePortal
                    style={{
                      position: "relative",
                      zIndex: 100,
                    }}
                  >
                    <ClickAwayListener onClickAway={handleClose}>
                      <Paper
                        elevation={3}
                        style={{ position: "relative", zIndex: 1 }}
                      >
                        <div
                          style={{
                            padding: 16,
                            borderRadius: 10,
                          }}
                        >
                          <DayPicker
                            className="react-day-picker"
                            mode="range"
                            selected={range}
                            onSelect={handleSelect}
                            // numberOfMonths={10}
                            month={month}
                            onMonthChange={handleMonthChange}
                            // styles={{
                            //   months: { display: "flex", gap: "16px" },
                            //   month: { margin: 0 },
                            // }}
                          />
                        </div>
                      </Paper>
                    </ClickAwayListener>
                  </Popper>
                </div>
                <Grid container spacing={2} pt={2}>
                  <Grid item xs={12} md={4} lg={4}>
                    <Tabs
                      value={tabValue}
                      onChange={handleSetTabValue}
                      orientation={tabsOrientation}
                      className="custom_tabs_links"
                    >
                      <Tab
                        sx={{ fontWeight: "500" }}
                        label={t.main.exchange}
                        {...a11yProps(0)}
                      />
                      <Tab
                        sx={{ fontWeight: "500" }}
                        label={t.main.return}
                        {...a11yProps(1)}
                      />
                    </Tabs>
                  </Grid>
                </Grid>
              </MDBox>
              <MDBox pt={3} pl={2} pr={2}>
                {rows.length > 0 ? (
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={false}
                    entriesPerPage={false}
                    showTotalEntries={false}
                    noEndBorder
                  />
                ) : (
                  <MDBox
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    py={5}
                  >
                    <MDTypography variant="h6" color="text">
                      {t.main.noData}
                    </MDTypography>
                  </MDBox>
                )}
              </MDBox>
              {orderData?.length > 0 && (
                <MDBox p={2}>
                  <Pagination
                    setPage={setPage}
                    module={orderData}
                    page={page}
                    onPageChange={setPage}
                    totalPages={totalPages}
                    limit={limit}
                    setLimit={setLimit}
                  />
                </MDBox>
              )}
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      <Footer />
      <WarnModal
        open={deleteModalOpen}
        setOpen={setDeleteModalOpen}
        handleDelete={() => handleDeleteOrder(selectedId)}
        name="Order"
      />
      <Dialog
        open={refundModal}
        onClose={handleCloseRefund}
        className="revert_dialog"
      >
        <DialogContent>
          <MDTypography variant="h5" fontWeight="medium" mb={1}>
            {t.main.setRefundAmount}
          </MDTypography>
          <form>
            <FormControl fullWidth>
              <MDBox mb={2}>
                <MDInput
                  type="text"
                  placeholder="Amount"
                  variant="outlined"
                  fullWidth
                  value={refundAmount}
                  onChange={(val) => setRefundAmount(val?.target?.value)}
                  error={error && !refundAmount}
                  inputProps={{ maxLength: 10 }}
                />
              </MDBox>
            </FormControl>
            <Box className="form_btn">
              <MDButton
                onClick={handleCloseRefund}
                variant="gradient"
                color="success"
                fullWidth
              >
                {t.main.cancel}
              </MDButton>
              <MDButton
                disabled={!refundAmount}
                onClick={() => {
                  handleSetRefundAmount(selectedExchange, tabValue);
                }}
                variant="gradient"
                color="success"
                fullWidth
              >
                {t.main.send}
              </MDButton>
            </Box>
          </form>
        </DialogContent>
      </Dialog>
    </DashboardLayout>
  );
};

export default ReturnExchangeManagement;
